import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import appReducer from './appReducer';

const reducer = combineReducers({
  app: appReducer
});

const sagaMiddleware = createSagaMiddleware();
const createStoreWithMiddleware = compose(
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
)(createStore);

const store = createStoreWithMiddleware(reducer, {});

export default store;
